import { render, staticRenderFns } from "./errorcomponent.vue?vue&type=template&id=33090be3&"
import script from "./errorcomponent.vue?vue&type=script&lang=js&"
export * from "./errorcomponent.vue?vue&type=script&lang=js&"
import style0 from "./errorcomponent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports